import React from "react";

const MyWishList = () => {
  return (
    <div>
      <h2 className="text-3xl mb-5 font-semibold">My WishList</h2>
    </div>
  );
};

export default MyWishList;
